// ファイル名: userDeliverableLogic.js

import { API_BASE_DELIVERABLE } from './constants';

const getHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
});

// ✅ 指定ユーザの現在進行中カリキュラムの成果物のみ取得
export const fetchDeliverables = async (userId) => {
  const res = await fetch(API_BASE_DELIVERABLE, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'listDeliverablesForUser',
      userId
    }),
  });
  return res.json();
};

export const confirmDeliverable = async (userId, curriculumName, sessionNumber) => {
  const res = await fetch(API_BASE_DELIVERABLE, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'confirmDeliverable',
      userId,
      curriculumName,
      sessionNumber
    }),
  });
  return res.json();
};

export const autoAdvanceUserIfReady = async (userId) => {
  const res = await fetch(API_BASE_DELIVERABLE, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'autoAdvanceIfEligible',
      userId
    }),
  });
  return res.json();
};

// ✅ 成果物確認・未確認状態取得
export const getDeliverableStatus = async (userId) => {
  const res = await fetch(API_BASE_DELIVERABLE, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({
      action: 'getDeliverableStatus',
      userId
    }),
  });
  return res.json();
};

// ✅ 成果物モーダル表示補助関数（画像クリック閲覧）
export const openDeliverableModal = async (
  userId,
  setModalData,
  startLoading,
  finishLoading,
  curriculumName,
  sessionNumber
) => {
  startLoading();
  try {
    const res = await fetchDeliverables(userId);
    setModalData({
      userId,
      curriculumName,
      sessionNumber,
      deliverables: res.files || [],
      confirmed: res.confirmed
    });
  } catch (e) {
    alert('成果物の取得に失敗しました');
    console.error(e);
  } finally {
    finishLoading();
  }
};

export const fetchDeliverableStatuses = async (userIds) => {
  const res = await fetch(API_BASE_DELIVERABLE, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'listDeliverableStatuses', userIds })
  });

  if (!res.ok) throw new Error('deliverableStatuses取得失敗');
  return await res.json(); // 形式: { statuses: { [userId]: { confirmed: boolean, passed: boolean } } }
};

export const handleUnconfirm = async (userId, curriculumName, sessionNumber) => {
  try {
    const res = await fetch(API_BASE_DELIVERABLE, {
      method: 'POST',
      headers: getHeaders(),  // ←ここ
      body: JSON.stringify({
        action: 'unconfirmDeliverable',
        userId,
        curriculumName,
        sessionNumber
      })
    });

    const result = await res.json();
    if (res.ok) {
      alert('未確認に戻しました');
    } else {
      alert(result.error || '未確認に戻せませんでした');
    }
  } catch (error) {
    console.error('unconfirmエラー:', error);
    alert('エラーが発生しました');
  }
};
